import { Modal, Space } from 'antd';
import styled from 'styled-components';

export const AddProductsFromAnotherProjectModal = styled(Modal)`
    width: 680px !important;
    height: 347px !important;

    .ant-modal-body {
        padding: 32px 40px 41px 40px;
    }

    .ant-modal-content {
        border-radius: 6px;
    }
`;

export const AddFromAProjectSpace = styled(Space)`
    margin-top: 16px;
    align-items: end;
    width: 100%;
    .ant-space-item:first-child {
        width: 70%;
    }
`;
